import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {Trans} from '@lingui/react';
import {t} from '@lingui/core/macro';

import {telegramChatAPI} from 'entities/notification';
import Telegram from 'shared/ui/icons/Telegram';
import TelegramNotBackground from 'shared/ui/icons/TelegramNotBackground';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import NotifyChannelBlock from '../NotifyChannelBlock/NotifyChannelBlock';

interface INotifyTelegramProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
}

const NotifyTelegram: React.FC<INotifyTelegramProps> = ({item, control, register}) => {
    const {data, isLoading} = telegramChatAPI.useGetActiveQuery();

    return (
        <NotifyChannelBlock
            items={data}
            isLoading={isLoading}
            getLabel={(chat) => chat.description ?? chat.chat}
            control={control}
            register={register}
            fieldName="telegram_chats"
            settingsField="notify_telegram_chats_settings"
            settings={item?.notify_telegram_chats_settings ?? []}
            icon={<TelegramNotBackground/>}
            connectIcon={<Telegram/>}
            title="Telegram"
            notConnectedText={<Trans id="text.subtitle.telegram" message="Уведомления через Telegram не подключены"/>}
            // eslint-disable-next-line max-len
            hint={t`Для отправки уведомлений о сбоях нужно подключить Telegram. После подключения вы сможете выбрать его в настройках монитора.`}
        />
    );
};

export default NotifyTelegram;
